import React from "react";
import {
  Theme,
  Flex,
  Text,
  Button,
  Link,
  Box,
  Card,
  Separator,
} from "@radix-ui/themes";
import {
  Calendar,
  Layers,
  ArrowRight,
  Github,
  Twitter,
  Linkedin,
  Globe,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

function HomePage() {
  const navigate = useNavigate();

  const sampleProfile = {
    name: "Kartik Mehta",
    username: "mehta",
    description:
      "I am the kind of programmer who’ll gladly spend 10 hours automating a task I could do in 10 minutes, haha.",
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/kartikmehta17",
      github: "https://github.com/kartikmehta8",
      twitter: "https://x.com/kartik_mehta8",
      website: "https://www.mrmehta.in",
    },
    theme: "midnight-glow",
    calcomUsername: "kartikmehta",
  };

  return (
    <Theme appearance="dark" accentColor="crimson" radius="medium">
      <Box
        style={{
          background: "linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%)",
          minHeight: "100vh",
        }}
      >
        <Flex
          justify="between"
          align="center"
          style={{
            padding: "1.5rem 2rem",
            borderBottom: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          <Flex align="center" gap="2">
            <Box
              style={{
                background: "linear-gradient(45deg, #8B004B, #FF0066)",
                width: "40px",
                height: "40px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Layers color="white" size={24} />
            </Box>
            <Text size="5" weight="bold" style={{ color: "#fff" }}>
              Profiles
            </Text>
          </Flex>

          <Flex gap="4" align="center" style={{ display: "flex" }}>
            <Button variant="soft" onClick={() => navigate("/login")}>
              Login
            </Button>
            <Button
              onClick={() => navigate("/signup")}
              style={{
                background: "linear-gradient(45deg, #FF0066)",
                border: "none",
              }}
            >
              Get Started
            </Button>
          </Flex>
        </Flex>

        <Flex
          direction="column"
          align="center"
          justify="center"
          style={{
            padding: "4rem 2rem",
            textAlign: "center",
          }}
          gap="6"
        >
          <Text
            size="9"
            weight="bold"
            style={{
              maxWidth: "800px",
              background: "linear-gradient(to right, #FF0066, #FB5B78)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            One Link. One Card. Your Complete Identity.
          </Text>

          <Text
            size="5"
            style={{ color: "#ccc", maxWidth: "600px", margin: "0 auto" }}
          >
            All your socials and schedule in one place—easy, beautiful, and
            yours.
          </Text>

          <Flex gap="4" style={{ marginTop: "1rem" }}>
            <Button
              size="3"
              onClick={() => navigate("/signup")}
              style={{
                background: "linear-gradient(45deg, #FF0066)",
                border: "none",
                padding: "0 28px",
              }}
            >
              Create Your Page{" "}
              <ArrowRight size={16} style={{ marginLeft: "0.5rem" }} />
            </Button>
          </Flex>
        </Flex>

        <Box style={{ padding: "2rem", maxWidth: "1200px", margin: "0 auto" }}>
          <Flex
            wrap="wrap"
            justify="center"
            gap="6"
            style={{ margin: "2rem 0" }}
          >
            <Card
              style={{
                width: "calc(33.333% - 2rem)",
                minWidth: "300px",
                background: "rgba(255,255,255,0.05)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 4px 24px rgba(0,0,0,0.2)",
                border: "1px solid rgba(255,255,255,0.08)",
                padding: "2rem",
                flex: "1 1 300px",
              }}
            >
              <Text size="5" weight="bold" style={{ marginBottom: "0.5rem" }}>
                Custom Links
              </Text>{" "}
              <br />
              <Text size="3" color="gray">
                Share all your important links in one place. Add links to your
                social media, portfolio, store, or any website you want to
                promote.
              </Text>
            </Card>

            <Card
              style={{
                width: "calc(33.333% - 2rem)",
                minWidth: "300px",
                background: "rgba(255,255,255,0.05)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 4px 24px rgba(0,0,0,0.2)",
                border: "1px solid rgba(255,255,255,0.08)",
                padding: "2rem",
                flex: "1 1 300px",
              }}
            >
              <Text size="5" weight="bold" style={{ marginBottom: "0.5rem" }}>
                Cal.com Integration
              </Text>{" "}
              <br />
              <Text size="3" color="gray">
                Let visitors book meetings directly from your profile. Seamless
                integration with Cal.com makes scheduling appointments
                effortless.
              </Text>
            </Card>

            <Card
              style={{
                width: "calc(33.333% - 2rem)",
                minWidth: "300px",
                background: "rgba(255,255,255,0.05)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 4px 24px rgba(0,0,0,0.2)",
                border: "1px solid rgba(255,255,255,0.08)",
                padding: "2rem",
                flex: "1 1 300px",
              }}
            >
              <Text size="5" weight="bold" style={{ marginBottom: "0.5rem" }}>
                Custom Themes
              </Text>{" "}
              <br />
              <Text size="3" color="gray">
                Make your profile reflect your personal brand with customizable
                themes. Choose colors, layouts, and styles that match your
                identity.
              </Text>
            </Card>
          </Flex>
        </Box>

        <Flex
          direction={{ initial: "column", md: "row" }}
          align="center"
          justify="between"
          gap="8"
          style={{
            padding: "5rem 2rem",
            maxWidth: "1200px",
            margin: "0 auto",
            borderRadius: "24px",
          }}
        >
          <Box style={{ maxWidth: "500px", padding: "0 1rem" }}>
            <Text
              size="8"
              weight="bold"
              style={{
                marginBottom: "1.5rem",
                background: "linear-gradient(to right, #FF0066, #FB5B78)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Your Professional Online Presence
            </Text>{" "}
            <br />
            <Text size="4" color="gray" style={{ marginBottom: "2rem" }}>
              Stand out with a stunning profile that showcases your identity.
              Connect all your important links and let visitors book meetings -
              all in one place.
            </Text>
            <Button
              size="3"
              onClick={() => navigate("/signup")}
              style={{
                marginTop: "1rem",
                background: "linear-gradient(45deg, #FF0066)",
                border: "none",
                padding: "0 28px",
              }}
            >
              Create Your Profile Now
            </Button>
          </Box>

          <Card
            style={{
              width: "340px",
              background: "linear-gradient(135deg, #111 0%, #222 100%)",
              border: "1px solid rgba(255,255,255,0.12)",
              boxShadow: "0 20px 40px rgba(0,0,0,0.5)",
              borderRadius: "20px",
              padding: "2rem 1.5rem",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Flex
              direction="column"
              align="center"
              gap="4"
              style={{ position: "relative", zIndex: "1" }}
            >
              <Text size="5" weight="bold">
                {sampleProfile.name}
              </Text>

              <Text
                size="2"
                color="gray"
                align="center"
                style={{ maxWidth: "260px" }}
              >
                {sampleProfile.description}
              </Text>

              <Flex gap="3" style={{ marginTop: "0.5rem" }}>
                <Link
                  href={sampleProfile.socialLinks.github}
                  style={{ color: "#fff" }}
                >
                  <Github size={20} />
                </Link>
                <Link
                  href={sampleProfile.socialLinks.twitter}
                  style={{ color: "#fff" }}
                >
                  <Twitter size={20} />
                </Link>
                <Link
                  href={sampleProfile.socialLinks.linkedin}
                  style={{ color: "#fff" }}
                >
                  <Linkedin size={20} />
                </Link>
                <Link
                  href={sampleProfile.socialLinks.website}
                  style={{ color: "#fff" }}
                >
                  <Globe size={20} />
                </Link>
              </Flex>

              <Separator size="4" style={{ width: "100%", margin: "1rem 0" }} />

              {["Portfolio", "Blog", "YouTube Channel"].map((link, i) => (
                <Button
                  key={i}
                  variant="surface"
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    background: "rgba(255,255,255,0.08)",
                    border: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  {link}
                </Button>
              ))}

              <Button
                style={{
                  width: "100%",
                  marginTop: "0.5rem",
                  justifyContent: "center",
                  background: "linear-gradient(to right, #8B004B, #FF0066)",
                  border: "none",
                }}
              >
                <Calendar size={16} style={{ marginRight: "0.5rem" }} /> Book a
                Meeting
              </Button>
            </Flex>
          </Card>
        </Flex>

        <Flex
          direction="column"
          align="center"
          justify="center"
          style={{
            padding: "6rem 2rem",
            textAlign: "center",
            background: "rgba(0,0,0,0.2)",
          }}
          gap="4"
        >
          <Text size="7" weight="bold" style={{ maxWidth: "700px" }}>
            Ready to create your personalized page?
          </Text>

          <Text
            size="3"
            color="gray"
            style={{ maxWidth: "600px", marginBottom: "1.5rem" }}
          >
            Join thousands of creators, professionals, and brands building their
            online presence.
          </Text>

          <Button
            size="4"
            onClick={() => navigate("/signup")}
            style={{
              background: "linear-gradient(45deg, #FF0066)",
              border: "none",
              padding: "0 32px",
            }}
          >
            Get Started For Free
          </Button>
        </Flex>

        <Flex
          direction="column"
          style={{
            padding: "2rem 2rem",
            borderTop: "1px solid rgba(255,255,255,0.1)",
          }}
          gap="4"
        >
          <Text size="1" color="gray" align="center">
            © {new Date().getFullYear()} Profiles. All rights reserved.
          </Text>
        </Flex>
      </Box>
    </Theme>
  );
}

export default HomePage;
